import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import * as yup from 'yup';
import { useFormik } from 'formik';
import Button from 'partial/components/Button';
import Form from 'partial/components/form';
import FormInputNumber from 'partial/components/form/FormInputNumber';
import { useEditRate } from '../hooks';

export const useOpenEditRate = () => {
  const createModal = useCreateModal();

  const openEditRateModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <EditRate data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openEditRateModal;
};

const initialValues = {
  rate_per_sms: '',
};

const validationSchema = yup.object().shape({
  rate_per_sms: yup.string().required('Required'),
});

function EditRate({ onClose, data }) {
  const { uuid, name, rate_per_sms: rate } = data;
  const [isLoading, update] = useEditRate(onClose);
  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (payload) => {
      update({
        uuid,
        name,
        rate_per_sms: +payload?.rate_per_sms,
      });
    },
    validateOnChange: false,
  });

  useEffect(() => {
    if (!rate) return;
    setFieldValue('rate_per_sms', rate);
  }, [rate, setFieldValue]);

  return (
    <ModalCard size="sm" title="UPDATE RATE RATIO" onClose={onClose}>
      <Form onSubmit={handleSubmit} error={errors} className="p-5 w-full">
        <FormInputNumber
          name="rate_per_sms"
          onSetFieldValue={setFieldValue}
          value={values.rate_per_sms}
          error={errors.rate_per_sms}
          label="Rate Ratio"
          required
        />
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isLoading}
            outline
            className="uppercase"
            type="submit"
          >
            save changes
          </Button>
        </div>
      </Form>
    </ModalCard>
  );
}

EditRate.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditRate;
